<template>
  <div v-if="entidad_data.posiciones && entidad_data.posiciones.length">
    <div class="card-body">
      <!-- Barra de herramientas -->
      <div class="row mb-3">
        <div class="col-12">
          <div v-if="div_cargando">
            <div class="text-center">
              <i class="fas fa-spinner fa-spin"></i> Cargando...
            </div>
          </div>
          <div class="btn-toolbar justify-content-start" role="toolbar">
            <!-- Grupo de controles de trazabilidad -->
            <div class="btn-group mr-2 mb-2" role="group">
              <button
                type="button"
                class="btn"
                :class="form.traza ? 'btn-primary' : 'btn-outline-primary'"
                @click="toggleTraza()"
                data-toggle="tooltip"
                data-placement="top"
                title="Activar/Desactivar Traza del Viaje"
              >
                <i class="fas fa-map-marked-alt mr-1"></i>
                <span class="d-none d-md-inline">Traza Viaje</span>
                <span v-if="form.traza" class="badge badge-light ml-1">ON</span>
              </button>
            </div>

            <!-- Grupo de controles de novedades -->
            <div class="btn-group mr-2 mb-2" role="group">
              <button
                type="button"
                class="btn"
                :class="form.novedades ? 'btn-warning' : 'btn-outline-warning'"
                @click="toggleNovedades()"
                data-toggle="tooltip"
                data-placement="top"
                title="Activar/Desactivar Novedades en el Mapa"
              >
                <i class="fas fa-exclamation-triangle mr-1"></i>
                <span class="d-none d-md-inline">Novedades</span>
                <span v-if="form.novedades" class="badge badge-light ml-1"
                  >ON</span
                >
              </button>
            </div>

            <!-- Grupo de controles de ruta -->
            <div class="btn-group mr-2 mb-2" role="group">
              <button
                type="button"
                class="btn"
                :class="form.ruta ? 'btn-info' : 'btn-outline-info'"
                @click="toggleRuta()"
                data-toggle="tooltip"
                data-placement="top"
                title="Activar/Desactivar Ruta en el Mapa"
              >
                <i class="fas fa-route mr-1"></i>
                <span class="d-none d-md-inline">Ruta</span>
                <span v-if="form.ruta" class="badge badge-light ml-1">ON</span>
              </button>
            </div>

            <!-- Grupo de controles de geocercas -->
            <div class="btn-group mr-2 mb-2" role="group">
              <button
                type="button"
                class="btn"
                :class="form.geocercas ? 'btn-info' : 'btn-outline-info'"
                @click="toggleGeocercas()"
                data-toggle="tooltip"
                data-placement="top"
                title="Activar/Desactivar Geocercas en el Mapa"
              >
                <i class="fas fa-draw-polygon mr-1"></i>
                <span class="d-none d-md-inline">Geocercas</span>
                <span v-if="form.geocercas" class="badge badge-light ml-1"
                  >ON</span
                >
              </button>
            </div>

            <!-- Botón de exportar -->
            <div class="btn-group mb-2" role="group">
              <button
                type="button"
                class="btn btn-success"
                @click="generarListadoExcel()"
                data-toggle="tooltip"
                data-placement="top"
                title="Exportar Trazabilidad a Excel"
              >
                <i class="far fa-file-excel mr-1"></i>
                <span class="d-none d-md-inline">Exportar Excel</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Leyenda de marcadores -->
      <div class="row mb-3">
        <div class="col-12">
          <div class="card card-outline card-info">
            <div class="card-body p-2">
              <div class="row text-center">
                <div class="col-md-3 col-6 mb-2">
                  <small>
                    <i class="fas fa-circle text-success mr-1"></i>
                    <strong>Punto Inicial</strong>
                  </small>
                </div>
                <div class="col-md-3 col-6 mb-2">
                  <small>
                    <i class="fas fa-circle text-primary mr-1"></i>
                    <strong>Punto Final</strong>
                  </small>
                </div>
                <div class="col-md-3 col-6 mb-2">
                  <small>
                    <i
                      class="fas fa-exclamation-triangle text-warning mr-1"
                    ></i>
                    <strong>Advertencias</strong>
                  </small>
                </div>
                <div class="col-md-3 col-6 mb-2">
                  <small>
                    <i class="fas fa-exclamation-circle text-danger mr-1"></i>
                    <strong>Emergencias</strong>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Mapa -->
      <div class="row">
        <div class="col-12">
          <div
            class="map-container"
            style="position: relative; border-radius: 4px; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.1);"
          >
            <gmap-map
              :center="center"
              :zoom="15"
              style="width: 100%; height: 500px"
            >
              <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :icon="m.icon"
                :animation="2"
                @click="toggleInfoWindow(m, index, m.info)"
              ></gmap-marker>

              <gmap-marker
                :key="index"
                v-for="(m, index) in markersAd"
                :position="m.position"
                :icon="m.icon"
                :animation="2"
                @click="toggleInfoWindow(m, index, m.info)"
              ></gmap-marker>

              <gmap-marker
                :key="index"
                v-for="(m, index) in markersEm"
                :position="m.position"
                :icon="m.icon"
                :animation="2"
                @click="toggleInfoWindow(m, index, m.info)"
              ></gmap-marker>
              <gmap-info-window
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen = false"
              >
                <div v-html="infoContent"></div>
              </gmap-info-window>
              <gmap-polygon
                :options="{ fillColor: '#FF0000' }"
                v-for="poligono in poligonos"
                :key="poligono.id"
                :paths="poligono.path"
                :editable="false"
                :draggable="false"
                @click="
                  toggleInfoWindowPoli(poligono, poligono.id, poligono.info)
                "
              />
              <gmap-circle
                v-for="circular in circunferencias"
                :key="circular.id"
                :center="circular.center"
                :radius="circular.radius"
                :info="circular.info"
                @click="
                  toggleInfoWindowCir(circular, circular.id, circular.info)
                "
              ></gmap-circle>
              <!-- Marcadores de origen y destino de la ruta -->
              <gmap-marker
                v-if="markers.inicio_ruta"
                :position="markers.inicio_ruta.position"
                :icon="markers.inicio_ruta.icon"
              ></gmap-marker>
              <gmap-marker
                v-if="markers.fin_ruta"
                :position="markers.fin_ruta.position"
                :icon="markers.fin_ruta.icon"
              ></gmap-marker>
              <!-- Polilíneas de tramos de la ruta -->
              <div v-if="form.ruta">
                <gmap-polyline
                  v-for="(tramo, index) in tramosRuta"
                  :key="index"
                  :options="{
                    strokeColor:
                      tramoSeleccionadoId === tramo.id
                        ? '#CD5C5C'
                        : tramo.color || '#ff1c79',
                    strokeOpacity:
                      tramoSeleccionadoId === tramo.id ? '1.0' : '0.7',
                    strokeWeight: tramoSeleccionadoId === tramo.id ? 12 : 8,
                    zIndex: tramoSeleccionadoId === tramo.id ? 1000 : 1,
                  }"
                  :path="tramo.path"
                  :editable="false"
                  @click="toggleInfoWindowTramo(tramo, $event)"
                >
                </gmap-polyline>
              </div>
            </gmap-map>
          </div>
        </div>
      </div>

      <!-- Mensaje informativo -->
      <div class="row mt-3">
        <div class="col-12">
          <div class="text-muted text-left">
            <small>
              <i class="fas fa-info-circle mr-1"></i>
              Haz clic en los marcadores para ver más información
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getRotacionFlechaTraza } from "@/utils/trazaGps";
export default {
  name: "GestionMapaHidrocarburos",

  data() {
    return {
      div_cargando: false,
      infoContent: "",
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      form: {
        geocercas: false,
        traza: false,
        novedades: false,
        ruta: false,
      },
      polylineOptions: {
        strokeColor: "#ff1c79",
        strokeOpacity: "0.7",
        strokeWeight: 8,
      },
      center: { lat: 4.651371, lng: -74.071509 },
      markers: [],
      markersAd: [],
      markersEm: [],
      pathRuta: [],
      pathPoli: [],
      tramosRuta: [],
      places: [],
      currentPlace: null,
      locations: {},
      poligonos: [],
      circunferencias: [],
      puntoInicialLat: null,
      puntoInicialLng: null,
      puntoFinalLat: null,
      puntoFinalLng: null,
      infoPuntoFinal: "",
      infoPuntoInicial: "",
      puntofin: null,
      vehiculo_id: null,
      latitud: null,
      longitud: null,
      puntosTraza: [],
      path: [],
      url_docs: process.env.VUE_APP_API_URL,
      tramoSeleccionadoId: null, // ID del tramo seleccionado para resaltarlo
    };
  },

  props: {
    entidad_data: {
      type: Object,
    },
    type_entidad: {
      type: String,
    },
  },

  methods: {
    // Función para crear icono de advertencia (amarillo) - fas fa-exclamation-triangle
    crearIconoAdvertencia() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#ffc107" stroke="#fff" stroke-width="2"/>
          <path d="M24 8 L8 38 L40 38 Z" fill="#fff" opacity="0.2"/>
          <path d="M24 8 L8 38 L40 38 Z" fill="none" stroke="#000" stroke-width="2" stroke-linejoin="round"/>
          <path d="M24 18 L24 28 M24 30 L24 32" stroke="#000" stroke-width="3" stroke-linecap="round"/>
        </svg>
      `;
      // eslint-disable-next-line no-undef
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        // eslint-disable-next-line no-undef
        scaledSize: new google.maps.Size(48, 48),
        // eslint-disable-next-line no-undef
        anchor: new google.maps.Point(24, 48),
      };
    },

    // Función para crear icono de emergencia (rojo) - fas fa-exclamation-circle
    crearIconoEmergencia() {
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
          <circle cx="24" cy="24" r="22" fill="#dc3545" stroke="#fff" stroke-width="2"/>
          <circle cx="24" cy="24" r="16" fill="none" stroke="#fff" stroke-width="1.5" opacity="0.3"/>
          <path d="M24 14 L24 26 M24 28 L24 30" stroke="#fff" stroke-width="3" stroke-linecap="round"/>
        </svg>
      `;
      // eslint-disable-next-line no-undef
      return {
        url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
        // eslint-disable-next-line no-undef
        scaledSize: new google.maps.Size(48, 48),
        // eslint-disable-next-line no-undef
        anchor: new google.maps.Point(24, 48),
      };
    },

    toggleTraza() {
      this.form.traza = !this.form.traza;
      this.getTrazabilidad();
    },

    toggleNovedades() {
      this.form.novedades = !this.form.novedades;
      this.getNovedades();
    },

    toggleRuta() {
      this.form.ruta = !this.form.ruta;
      this.getRuta();
    },

    toggleGeocercas() {
      this.form.geocercas = !this.form.geocercas;
      this.getGeocercas();
    },

    async getTrazabilidad() {
      this.puntosTraza = [];
      this.markers = [];
      if (this.form.traza) {
        this.puntosTraza = await this.entidad_data.posiciones;
        this.trazaViaje();
      }
    },

    trazaViaje() {
      if (this.puntosTraza.length > 0) {
        this.puntosTraza.forEach((loc1, index) => {
          const latStr = String(loc1.latitud || "").replace(",", ".");
          const lngStr = String(loc1.longitud || "").replace(",", ".");
          const marker = {
            lat: parseFloat(latStr),
            lng: parseFloat(lngStr),
          };
          const rotacion = getRotacionFlechaTraza(this.puntosTraza, index);

          const path = `
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="30">
                  <circle cx="13" cy="13.5" r="13" stroke="white" stroke-width="2" fill="#00529c"></circle>
                  <path 
                    fill="#b0c442"
                    stroke="white" 
                    stroke-width="1" 
                    d="M 7 7 L 13 11 L 19 7 L 13 21 Z" 
                    transform="rotate(${rotacion}, 13, 13)">
                  </path>
                  <rect width="39" height="15" fill="black" stroke="black" x="26" y="6"></rect>
                  <text font-size="10" font-family="" x="28" y="16" fill="white">
                    ${loc1.placa || ""}
                  </text>
                </svg>
              `;
          const encodedPath = encodeURIComponent(path);
          const iconUrl = "data:image/svg+xml;charset=UTF-8," + encodedPath;

          let svgMarker = {
            url: iconUrl,
            fillColor: "#b0c442",
            fillOpacity: 1,
            strokeColor: "#00529c",
            strokeWeight: 1,
            strokeOpacity: 0.7,
            rotation: rotacion,
            scale: 0.7,
            // eslint-disable-next-line no-undef
            anchor: new google.maps.Point(15, 30),
          };

          this.markers.push({
            position: marker,
            icon: svgMarker,
            info: loc1.ventana,
            center: { marker },
            rotate: rotacion + 180,
          });
        });

        const latIniStr = String(this.puntosTraza[0].latitud || "").replace(
          ",",
          "."
        );
        const lngIniStr = String(this.puntosTraza[0].longitud || "").replace(
          ",",
          "."
        );
        this.puntoInicialLat = parseFloat(latIniStr);
        this.puntoInicialLng = parseFloat(lngIniStr);
        this.infoPuntoInicial = this.puntosTraza[0].ventana;

        this.markers.push({
          id: this.puntosTraza[0].id,
          position: {
            lat: this.puntoInicialLat,
            lng: this.puntoInicialLng,
          },
          icon: "/img/icon_punto_g_ok.png",
          info: this.infoPuntoInicial,
        });

        this.puntofin = this.puntosTraza.slice(-1);
        const latFinStr = String(this.puntofin[0].latitud || "").replace(
          ",",
          "."
        );
        const lngFinStr = String(this.puntofin[0].longitud || "").replace(
          ",",
          "."
        );
        this.puntoFinalLat = parseFloat(latFinStr);
        this.puntoFinalLng = parseFloat(lngFinStr);
        this.infoPuntoFinal = this.puntofin[0].ventana;

        this.markers.push({
          id: this.puntofin[0].id,
          position: {
            lat: this.puntoFinalLat,
            lng: this.puntoFinalLng,
          },
          icon: "/img/icon_punto_g.png",
          info: this.infoPuntoFinal,
        });

        const marker1 = {
          lat: this.puntoFinalLat,
          lng: this.puntoFinalLng,
        };
        this.center = marker1;
      } else {
        this.$swal({
          title: "Tramas no encontradas!",
          text: "No se encontraron tramas para este viaje",
          icon: "warning",
        });
      }
    },

    async getNovedades() {
      this.path = [];
      this.markersAd = [];
      this.markersEm = [];

      if (!this.form.novedades) {
        return;
      }

      // Verificar si tenemos un viaje_id disponible
      const viaje_id =
        this.type_entidad === "Viaje"
          ? this.entidad_data.id
          : this.entidad_data.id;

      if (!viaje_id) {
        this.$swal({
          icon: "warning",
          title: "No se puede cargar novedades",
          text: "No se encontró un ID de viaje válido",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      let me = this;
      await axios
        .get("/api/hidrocarburos/reportenovedades/Mapa", {
          params: { viaje: viaje_id },
        })
        .then(async function(response) {
          me.markersAd = [];
          me.markersEm = [];

          const datosNovedades = response.data.advertencia;
          if (me.form.novedades == true) {
            await datosNovedades.forEach((nov) => {
              if (nov.latitud != null && nov.longitud != null) {
                const borderClass =
                  nov.relevancia == 1 ? "border-warning" : "border-danger";
                const headerClass =
                  nov.relevancia == 1
                    ? "bg-warning text-dark"
                    : "bg-danger text-white";
                const badgeClass =
                  nov.relevancia == 1 ? "badge-warning" : "badge-danger";
                let ventana =
                  '<div class="card ' +
                  borderClass +
                  '" style="min-width: 250px;">' +
                  '<div class="card-header ' +
                  headerClass +
                  '">' +
                  '<h5 class="card-title mb-0"><i class="fas fa-exclamation-triangle mr-2"></i>Vehículo: ' +
                  nov.vehiculo.placa +
                  "</h5></div>" +
                  '<div class="card-body">' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-calendar-alt mr-1"></i>Fecha:</strong> ' +
                  nov.fecha_novedad +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-route mr-1"></i>Viaje:</strong> ' +
                  nov.viaje_id +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-truck mr-1"></i>Transportadora:</strong> ' +
                  (nov.viaje.transportadora
                    ? nov.viaje.transportadora.razon_social
                    : "Sin asignar") +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-map-marker-alt mr-1"></i>Posición:</strong> ' +
                  nov.latitud +
                  ", " +
                  nov.longitud +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-tachometer-alt mr-1"></i>Velocidad:</strong> ' +
                  nov.velocidad +
                  " Km/h</p>" +
                  "<hr>" +
                  '<p class="card-text mb-0"><strong><i class="fas fa-info-circle mr-1"></i>Novedad:</strong><br>' +
                  '<span class="badge ' +
                  badgeClass +
                  '">' +
                  nov.nTipoNovedad +
                  " - " +
                  nov.nSubNovedad +
                  "</span></p>" +
                  "</div></div>";
                const marker = {
                  lat: parseFloat(nov.latitud),
                  lng: parseFloat(nov.longitud),
                };
                me.markersAd.push({
                  position: marker,
                  icon:
                    nov.relevancia == 2
                      ? me.crearIconoEmergencia()
                      : me.crearIconoAdvertencia(),
                  info: ventana,
                  center: {
                    marker,
                  },
                });
              }
            });

            const datosNovedadesEmerg = response.data.emergencia;
            await datosNovedadesEmerg.forEach((nov) => {
              if (nov.latitud != null && nov.longitud != null) {
                const borderClass =
                  nov.relevancia == 1 ? "border-warning" : "border-danger";
                const headerClass =
                  nov.relevancia == 1
                    ? "bg-warning text-dark"
                    : "bg-danger text-white";
                const badgeClass =
                  nov.relevancia == 1 ? "badge-warning" : "badge-danger";
                let ventana =
                  '<div class="card ' +
                  borderClass +
                  '" style="min-width: 250px;">' +
                  '<div class="card-header ' +
                  headerClass +
                  '">' +
                  '<h5 class="card-title mb-0"><i class="fas fa-exclamation-circle mr-2"></i>Vehículo: ' +
                  nov.vehiculo.placa +
                  "</h5></div>" +
                  '<div class="card-body">' +
                  '<p class="card-text mb-2"><strong><i class="fas fa-calendar-alt mr-1"></i>Fecha:</strong> ' +
                  nov.fecha_novedad +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-route mr-1"></i>Viaje:</strong> ' +
                  nov.viaje_id +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-truck mr-1"></i>Transportadora:</strong> ' +
                  (nov.viaje.transportadora
                    ? nov.viaje.transportadora.razon_social
                    : "Sin asignar") +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-map-marker-alt mr-1"></i>Posición:</strong> ' +
                  nov.latitud +
                  ", " +
                  nov.longitud +
                  "</p>" +
                  '<p class="card-text mb-2"><strong><i class="fas fa-tachometer-alt mr-1"></i>Velocidad:</strong> ' +
                  nov.velocidad +
                  " Km/h</p>" +
                  "<hr>" +
                  '<p class="card-text mb-0"><strong><i class="fas fa-info-circle mr-1"></i>Novedad:</strong><br>' +
                  '<span class="badge ' +
                  badgeClass +
                  '">' +
                  nov.nTipoNovedad +
                  " - " +
                  nov.nSubNovedad +
                  "</span></p>" +
                  "</div></div>";
                const marker = {
                  lat: parseFloat(nov.latitud),
                  lng: parseFloat(nov.longitud),
                };
                me.markersEm.push({
                  position: marker,
                  icon:
                    nov.relevancia == 2
                      ? me.crearIconoEmergencia()
                      : me.crearIconoAdvertencia(),
                  info: ventana,
                  center: {
                    marker,
                  },
                });
              }
            });
          }
        })
        .catch(function(error) {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    async getGeocercas() {
      this.poligonos = [];
      this.circunferencias = [];

      if (!this.form.geocercas) {
        return;
      }

      // Verificar si tenemos un viaje_id disponible
      const viaje_id =
        this.type_entidad === "Viaje"
          ? this.entidad_data.id
          : this.entidad_data.id;

      if (!viaje_id) {
        this.$swal({
          icon: "warning",
          title: "No se puede cargar geocercas",
          text: "No se encontró un ID de viaje válido",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      let me = this;
      await axios
        .get("/api/hidrocarburos/mapas/showGeocercasRuta", {
          params: { viaje_id: viaje_id },
        })
        .then(async function(response) {
          me.poligonos = [];
          me.circunferencias = [];

          if (me.form.geocercas == true) {
            const locations = response.data.gps_fin;

            // Procesar geocercas poligonales
            if (locations && locations.geocerca_poli) {
              await locations.geocerca_poli.forEach((geocerca) => {
                if (geocerca.puntos && geocerca.puntos.length > 0) {
                  let puntos = [];
                  geocerca.puntos.forEach((punto) => {
                    puntos.push({
                      lng: parseFloat(punto.longitud),
                      lat: parseFloat(punto.latitud),
                    });
                  });

                  me.poligonos.push({
                    id: geocerca.id,
                    name: geocerca.desc,
                    path: puntos,
                    info: geocerca.ventana,
                    color: geocerca.color,
                  });
                }
              });
            }

            // Procesar geocercas circulares
            if (locations && locations.geocerca_cir) {
              for (var j = 0; j < locations.geocerca_cir.length; j++) {
                if (
                  locations.geocerca_cir[j]["lat"] !== "" &&
                  locations.geocerca_cir[j]["lat"] !== null
                ) {
                  me.circunferencias.push({
                    center: {
                      lat: parseFloat(locations.geocerca_cir[j]["lat"]),
                      lng: parseFloat(locations.geocerca_cir[j]["lon"]),
                    },
                    radius: parseFloat(locations.geocerca_cir[j]["radio"]),
                    info: locations.geocerca_cir[j]["ventana"],
                    color: locations.geocerca_cir[j]["color"],
                  });
                }
              }
            }
          }
        })
        .catch(function(error) {
          me.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    getRuta() {
      // Si la ruta está desactivada, limpiar los datos y la selección
      if (!this.form.ruta) {
        //this.tramosRuta = [];
        this.tramoSeleccionadoId = null;
        return;
      }

      // Verificar que existan los datos necesarios
      if (
        !this.entidad_data ||
        !this.entidad_data.ruta ||
        !this.entidad_data.ruta.rutas_tramos
      ) {
        return;
      }

      this.center = {
        lat:
          this.entidad_data.ruta &&
          this.entidad_data.ruta.origen &&
          this.entidad_data.ruta.origen.latitud
            ? parseFloat(this.entidad_data.ruta.origen.latitud)
            : 4.651371,
        lng:
          this.entidad_data.ruta &&
          this.entidad_data.ruta.origen &&
          this.entidad_data.ruta.origen.longitud
            ? parseFloat(this.entidad_data.ruta.origen.longitud)
            : -74.071509,
      };

      let tramos = this.entidad_data.ruta.rutas_tramos;

      // Si no hay tramos, salir
      if (!tramos || tramos.length === 0) {
        return;
      }

      if (this.tramosRuta.length == 0) {
        // Activar indicador de carga
        this.$parent.$parent.$parent.cargando = true;

        // Obtener los datos completos de cada tramo
        const promesas = tramos.map(async (tramo) => {
          const tramoId =
            tramo.tramo_ruta_id || tramo.id || tramo.tramo_ruta?.id;
          if (!tramoId) {
            console.warn("Tramo sin ID válido:", tramo);
            return Promise.resolve(null);
          }

          try {
            const tramoResponse = await axios.get(
              `/api/admin/tramosRutas/${tramoId}`
            );
            const tramoCompleto = tramoResponse.data.data || tramoResponse.data;

            // Construir el path del tramo
            let path = [];
            if (
              tramoCompleto.det_tramos_rutas &&
              tramoCompleto.det_tramos_rutas.length > 0
            ) {
              // Ordenar los detalles por orden antes de construir el path
              const detallesOrdenados = [
                ...tramoCompleto.det_tramos_rutas,
              ].sort((a, b) => {
                return (a.orden || 0) - (b.orden || 0);
              });

              detallesOrdenados.forEach((det) => {
                if (det.orden == 1) {
                  path.push({
                    lat: parseFloat(det.lat_ini),
                    lng: parseFloat(det.lon_ini),
                  });
                }
                path.push({
                  lat: parseFloat(det.lat_fin),
                  lng: parseFloat(det.lon_fin),
                });
              });
            } else if (
              tramoCompleto.lat_origen &&
              tramoCompleto.lng_origen &&
              tramoCompleto.lat_destino &&
              tramoCompleto.lng_destino
            ) {
              path = [
                {
                  lat: parseFloat(tramoCompleto.lat_origen),
                  lng: parseFloat(tramoCompleto.lng_origen),
                },
                {
                  lat: parseFloat(tramoCompleto.lat_destino),
                  lng: parseFloat(tramoCompleto.lng_destino),
                },
              ];
            }

            return {
              ...tramoCompleto,
              path: path,
            };
          } catch (error) {
            console.error(`Error al obtener tramo ${tramoId}:`, error);
            return null;
          }
        });

        // Esperar a que todas las promesas se resuelvan
        Promise.all(promesas)
          .then((tramosCompletos) => {
            this.tramosRuta = tramosCompletos.filter(
              (t) => t !== null && t.path && t.path.length > 0
            );
          })
          .catch((error) => {
            console.error("Error al cargar los tramos:", error);
            this.$swal({
              icon: "error",
              title: "Error al cargar la ruta",
              text: "No se pudieron cargar todos los tramos de la ruta",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          })
          .finally(() => {
            // Desactivar indicador de carga cuando todas las consultas terminen
            this.$parent.$parent.$parent.cargando = false;
          });
      }
    },

    toggleInfoWindow: function(marker, idx, ventana) {
      this.infoWindowPos = marker.position;
      this.infoContent = ventana;
      this.center = marker.position;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowPoli: function(poli, idx, ventana) {
      this.infoWindowPos = poli.path[0];
      this.infoContent = ventana;
      this.center = poli.path[0];

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    toggleInfoWindowCir: function(cir, idx, ventana) {
      this.infoWindowPos = cir.center;
      this.infoContent = ventana;
      this.center = cir.center;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },

    obtenerPuntoMedioTramo: function(tramo) {
      // Calcular el punto medio entre origen y destino
      const lat1 = tramo.path[0].lat;
      const lng1 = tramo.path[0].lng;
      const lat2 = tramo.path[1].lat;
      const lng2 = tramo.path[1].lng;

      return {
        lat: (lat1 + lat2) / 2,
        lng: (lng1 + lng2) / 2,
      };
    },

    toggleInfoWindowTramo: function(tramo, event) {
      // Marcar este tramo como seleccionado para resaltarlo
      this.tramoSeleccionadoId = tramo.id;

      // Obtener la posición del click o el punto medio del tramo
      let position = null;

      if (event && event.latLng) {
        position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
      } else {
        // Si no hay latLng en el evento, usar el punto medio del tramo
        position = this.obtenerPuntoMedioTramo(tramo);
      }

      // Construir el contenido del popup con la información de velocidad
      const velocidad = tramo.vel_max || "No definida";
      const contenido = `
        <div class="card border-info" style="min-width: 250px;">
          <div class="card-header bg-info text-white">
            <h5 class="card-title mb-0">
              <i class="fas fa-route mr-2"></i>${tramo.nombre}
            </h5>
          </div>
          <div class="card-body">
            <p class="card-text mb-2">
              <strong><i class="fas fa-tachometer-alt mr-1"></i>Velocidad Máxima:</strong>
              <span class="badge badge-primary ml-1">${velocidad} ${
        velocidad !== "No definida" ? "km/h" : ""
      }</span>
            </p>
            ${
              tramo.tramo_ruta && tramo.tramo_ruta.distancia
                ? `
            <p class="card-text mb-0">
              <strong><i class="fas fa-ruler mr-1"></i>Distancia:</strong>
              <span class="ml-1">${tramo.tramo_ruta.distancia} km</span>
            </p>
            `
                : ""
            }
          </div>
        </div>
      `;

      // Centrar el mapa en la posición del click o punto medio del tramo
      this.$nextTick(() => {
        this.center = {
          lat:
            this.entidad_data.ruta &&
            this.entidad_data.ruta.origen &&
            this.entidad_data.ruta.origen.latitud
              ? this.entidad_data.ruta.origen.latitud
              : position.lat,
          lng:
            this.entidad_data.ruta &&
            this.entidad_data.ruta.origen &&
            this.entidad_data.ruta.origen.longitud
              ? this.entidad_data.ruta.origen.longitud
              : position.lng,
        };
      });

      this.infoWindowPos = position;
      this.infoContent = contenido;

      // Verificar si es el mismo tramo seleccionado para hacer toggle
      const tramoId = `tramo-${tramo.id || tramo.nombre}`;
      if (this.currentMidx == tramoId) {
        this.infoWinOpen = !this.infoWinOpen;
        // Si se cierra el info window, mantener el resaltado
        if (!this.infoWinOpen) {
          // Opcional: deseleccionar al cerrar
          // this.tramoSeleccionadoId = null;
        }
      } else {
        this.infoWinOpen = true;
        this.currentMidx = tramoId;
      }
    },

    generarListadoExcel() {
      // Verificar si tenemos un viaje_id disponible
      const viaje_id =
        this.type_entidad === "Viaje"
          ? this.entidad_data.id
          : this.entidad_data.id;

      if (!viaje_id) {
        this.$swal({
          icon: "warning",
          title: "No se puede exportar",
          text: "No se encontró un ID de viaje válido",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/viajes/trazaExport",
        data: { viaje_id },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },

    limpiarTramo() {
      this.tramoSeleccionadoId = null;
      this.tramosRuta = [];
      this.markers = [];
      this.pathRuta = [];
      this.pathPoli = [];
    },
  },
};
</script>

<style scoped>
.map-container {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
}

.card-header {
  border-bottom: 2px solid rgba(0, 0, 0, 0.125);
}

.btn-group .btn {
  transition: all 0.3s ease;
}

.btn-group .btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.btn-group .btn:active {
  transform: translateY(0);
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .btn-toolbar {
    flex-direction: column;
  }

  .btn-group {
    width: 100%;
  }

  .btn-group .btn {
    width: 100%;
    margin-bottom: 0.5rem;
  }
}

/* Info window styles */
::v-deep .gm-style-iw {
  padding: 0 !important;
}

::v-deep .gm-style-iw-d {
  overflow: hidden !important;
}

::v-deep .gm-style-iw-c {
  padding: 0 !important;
  border-radius: 4px !important;
}
</style>
